import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import { useTranslate } from '@im/react-localization';
import { Product } from '../../hooks/vpn-list';
import AddIcon from '@mui/icons-material/Add';

interface VpnErrorMessagePrps {
  MessageProp: string | undefined;
  ModeProp: string;
  RowsProp: Product[];
  is_product_member_exclude: string;
}
interface VpnButtonProps {
  IsRemove: boolean;
  onhandleAddSKUlist: () => void;
  onhandleClose: (() => void | undefined) | undefined;
  onreprocessMsgprops: () => void;
  rows: Product[];
}
export function VpnButton(props: Readonly<VpnButtonProps>) {
  const translate = useTranslate();
  return (
    <Stack
      direction="row"
      justifyContent={'flex-end'}
      marginTop="auto"
      paddingX={`16px`}
      paddingY={`24px`}
      spacing={`12px`}
    >
      <Button
        data-testid="gds-vp-addvpn-btnpoup-btn"
        onClick={() => {
          props.onreprocessMsgprops();
          props.onhandleClose?.();
        }}
        variant="newOutlined"
      >
        {translate('Common.Cancel')}
      </Button>
      <Button
        data-testid="gds-vp-addvpn-add-btnpoup-btn"
        disabled={props.rows.length === 0}
        onClick={() => {
          props.onhandleAddSKUlist();
        }}
        startIcon={<AddIcon />}
        variant="newContained"
      >
        {translate(
          props.IsRemove
            ? 'VendorDeals.RemoveSelectedRow'
            : 'VendorProgram.AddSkuToInclusionList'
        )}
      </Button>
    </Stack>
  );
}
export function VpnErrorMessage(props: Readonly<VpnErrorMessagePrps>) {
  const translate = useTranslate();
  return (
    <Stack>
      {props.MessageProp === 'Success' && (
        <Box
          alignItems={'center'}
          display={'flex'}
          flexDirection={'column'}
          height={'50vh'}
          justifyContent={'center'}
        >
          <CheckCircleIcon sx={{ color: '#1976d2', fontSize: 64 }} />
          <Typography variant="h1">
            {props.RowsProp.length}{' '}
            {translate('VendorProgram.VendorVpnAddErrorMesg', {
              mode: props.ModeProp === 'Yes' ? 'Exclusion' : 'Inclusion',
            })}
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
